(function(global) {
  function buildShopifySrcset(url, widthsCsv) {
    if (!url) return '';
    const widths = String(widthsCsv || '')
      .split(',')
      .map(function (w) { return w.trim(); })
      .filter(Boolean);
    if (!widths.length) return '';
    return widths
      .map(function (w) {
        const sized = /([?&])width=\d+/.test(url)
          ? url.replace(/([?&])width=\d+/, '$1width=' + w)
          : url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
        return sized + ' ' + w + 'w';
      })
      .join(', ');
  }

  function hydrateDeferredProductMedia(root, options) {
    if (!root) return;
    const includeHidden = Boolean(options && options.includeHidden);

    function isEffectivelyHidden(el) {
      if (!(el instanceof HTMLElement)) return true;
      if (includeHidden) return false;
      var node = el;
      while (node && node !== root) {
        if (node instanceof HTMLElement) {
          if (node.hasAttribute('hidden') || node.getAttribute('aria-hidden') === 'true') return true;
          if (node.style.display === 'none') return true;
        }
        node = node.parentElement;
      }
      return false;
    }

    root.querySelectorAll('.product-media--deferred[data-deferred-image]').forEach(function (el) {
      if (!(el instanceof HTMLElement)) return;
      if (isEffectivelyHidden(el)) return;
      if (el.querySelector('img.product-media__image')) return;
      var url = el.getAttribute('data-deferred-image') || '';
      if (!url) return;
      var img = document.createElement('img');
      img.className = 'product-media__image';
      img.alt = el.getAttribute('data-deferred-alt') || '';
      img.decoding = 'async';
      img.loading = 'lazy';
      img.sizes = el.getAttribute('data-deferred-sizes') || '100vw';
      var srcset = buildShopifySrcset(url, el.getAttribute('data-deferred-widths') || '400,600,800,1000,1200');
      if (srcset) img.srcset = srcset;
      img.src = url;
      el.appendChild(img);
      el.classList.remove('product-media--deferred');
    });

    root.querySelectorAll('.dialog-thumbnails-list__thumbnail--deferred[data-deferred-image]').forEach(function (el) {
      if (!(el instanceof HTMLElement)) return;
      if (isEffectivelyHidden(el)) return;
      if (el.querySelector('img')) return;
      var url = el.getAttribute('data-deferred-image') || '';
      if (!url) return;
      var img = document.createElement('img');
      img.src = url;
      img.alt = el.getAttribute('data-deferred-alt') || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      el.appendChild(img);
      el.classList.remove('dialog-thumbnails-list__thumbnail--deferred');
    });
  }

  if (typeof global.hydrateDeferredProductMedia !== 'function') {
    global.hydrateDeferredProductMedia = hydrateDeferredProductMedia;
  }

  function initProductMediaGalleryFullWidth(sectionId) {
  if (!sectionId) return;
  if (global._productMediaGalleryInits && global._productMediaGalleryInits[sectionId]) return;
  if (!global._productMediaGalleryInits) global._productMediaGalleryInits = {};
  global._productMediaGalleryInits[sectionId] = true;
  const PRODUCT_LAYOUT_DESKTOP_MIN = 1025;
  const PRODUCT_GALLERY_DESKTOP_MIN = 750;
  const PRODUCT_GALLERY_PHONE_MAX = PRODUCT_GALLERY_DESKTOP_MIN - 1;

  function isMobileProductViewport() {
    return window.matchMedia('(max-width: ' + (PRODUCT_LAYOUT_DESKTOP_MIN - 1) + 'px)').matches;
  }

  function isPhoneGalleryViewport() {
    return window.matchMedia('(max-width: ' + PRODUCT_GALLERY_PHONE_MAX + 'px)').matches;
  }

  function syncGalleryVideoAutoplay(slideshow) {
    if (!slideshow || !isPhoneGalleryViewport()) return;

    slideshow.querySelectorAll('deferred-media[autoplay]').forEach(function(deferredMedia) {
      if (typeof deferredMedia.syncAutoplay === 'function') {
        deferredMedia.syncAutoplay();
      }
    });
  }

  function scheduleGalleryVideoAutoplay(slideshow) {
    if (!slideshow) return;

    syncGalleryVideoAutoplay(slideshow);
    requestAnimationFrame(function() {
      syncGalleryVideoAutoplay(slideshow);
    });
    setTimeout(function() {
      syncGalleryVideoAutoplay(slideshow);
    }, 150);
  }

  function setupGalleryVideoAutoplay(slideshow) {
    if (!slideshow || slideshow._galleryVideoAutoplayInit) return;
    slideshow._galleryVideoAutoplayInit = true;

    slideshow.addEventListener('slideshow:select', function() {
      scheduleGalleryVideoAutoplay(slideshow);
    });

    const slidesContainer = slideshow.querySelector('slideshow-slides');
    if (slidesContainer) {
      const onScrollEnd = function() {
        scheduleGalleryVideoAutoplay(slideshow);
      };

      if ('onscrollend' in slidesContainer) {
        slidesContainer.addEventListener('scrollend', onScrollEnd, { passive: true });
      } else {
        let scrollEndTimer;
        slidesContainer.addEventListener(
          'scroll',
          function() {
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(onScrollEnd, 120);
          },
          { passive: true }
        );
      }
    }

    scheduleGalleryVideoAutoplay(slideshow);
  }
  
  function normalizeString(str) {
    if (!str) return '';
    return String(str).toLowerCase().replace(/[\s\-_|]/g, '');
  }

  function hideDuplicateMediaSlides(slideshow) {
    if (!slideshow) return;

    const seen = new Set();
    slideshow.querySelectorAll('slideshow-slide:not([data-gallery-clone])').forEach((slide) => {
      const mediaId = slide.getAttribute('data-media-id');
      if (!mediaId) return;

      if (seen.has(mediaId)) {
        slide.style.display = 'none';
        slide.setAttribute('hidden', '');
        slide.setAttribute('aria-hidden', 'true');
        return;
      }

      seen.add(mediaId);
    });
  }

  function dedupeSlidesByMediaId(slides) {
    const seen = new Set();
    return slides.filter((slide) => {
      const mediaId = slide.getAttribute('data-media-id');
      if (!mediaId) return true;
      if (seen.has(mediaId)) return false;
      seen.add(mediaId);
      return true;
    });
  }
  
  // Make normalizeString available globally for use in event handlers
  window.normalizeString = normalizeString;
  
  function filterMediaByColor(mediaGallery, colorValue, options) {
    if (!mediaGallery) {
      return 0;
    }

    const opts = options || {};
    const isInitialBoot = opts.isInitialBoot === true;
    const normalizedRequested = normalizeString(colorValue || '');

    // Skip redundant boot/filter passes that reflow media and cause a double flash
    if (
      isInitialBoot &&
      mediaGallery.dataset.galleryColorFiltered === normalizedRequested &&
      mediaGallery.dataset.galleryBootFiltered === 'true'
    ) {
      return getVisibleSlidesFromSlideshow(mediaGallery).length;
    }

    // Same color already applied this session — skip duplicate work from dual listeners (INP).
    if (
      !isInitialBoot &&
      normalizedRequested &&
      mediaGallery.dataset.galleryColorFiltered === normalizedRequested
    ) {
      return getVisibleSlidesFromSlideshow(mediaGallery).length;
    }

    // Cancel in-flight deferred heavy work from a prior rapid color tap (INP).
    const filterGen = (mediaGallery._galleryFilterGen = (mediaGallery._galleryFilterGen || 0) + 1);

    // Inject other-color shells from deferred map before filtering (selected color is SSR'd).
    if (!isInitialBoot && normalizedRequested) {
      ensureDeferredColorMedia(normalizedRequested);
    }

    const slidesContainer = mediaGallery.querySelector('slideshow-slides');
    if (slidesContainer) {
      removeGalleryClones(slidesContainer);
    }

    const slides = mediaGallery.querySelectorAll('slideshow-slide:not([data-gallery-clone])');
    let visibleCount = 0;
    /** @type {HTMLElement[]} */
    const matchingSlides = [];
    /** @type {HTMLElement[]} */
    const pendingHydrate = [];
    let hydratedFirst = false;

    if (!colorValue || colorValue.trim() === '') {
      // No color key — hide slides without parseable alt color; show the rest.
      slides.forEach((slide) => {
        const role = slide.getAttribute('data-media-role') || '';
        const position = parseInt(slide.getAttribute('data-media-position') || '999', 10);
        let mediaColor = normalizeString(slide.getAttribute('data-media-color') || '');
        if (!mediaColor && window.ProductCardServices?.parseMediaAlt) {
          const alt =
            slide.getAttribute('data-media-alt') ||
            slide.querySelector('img, video')?.getAttribute('alt') ||
            '';
          const src =
            slide.getAttribute('data-media-src') ||
            slide.querySelector('img')?.getAttribute('src') ||
            slide.querySelector('img')?.getAttribute('data-src') ||
            '';
          mediaColor = normalizeString(
            window.ProductCardServices.parseMediaAlt(src, { alt }).normalizedColor || ''
          );
        }
        if (role === 'swatch' || !mediaColor) {
          slide.style.display = 'none';
          slide.setAttribute('hidden', '');
          slide.setAttribute('aria-hidden', 'true');
          return;
        }
        slide.style.display = '';
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'false');
        if (typeof window.hydrateDeferredProductMedia === 'function') {
          if (!hydratedFirst || isInitialBoot) {
            window.hydrateDeferredProductMedia(slide);
            hydratedFirst = true;
          } else {
            pendingHydrate.push(slide);
          }
        }
        visibleCount++;
      });
    } else {
      // Match against normalized alt-text media color (e.g. black-1 → black).
      const normalizedColor = normalizeString(colorValue);

      slides.forEach((slide) => {
        const role = slide.getAttribute('data-media-role') || '';
        const position = parseInt(slide.getAttribute('data-media-position') || '999', 10);
        if (role === 'swatch') {
          slide.style.display = 'none';
          slide.setAttribute('hidden', '');
          slide.setAttribute('aria-hidden', 'true');
          return;
        }

        let mediaColor = slide.getAttribute('data-media-color') || '';
        if (!mediaColor && window.ProductCardServices?.parseMediaAlt) {
          const alt =
            slide.getAttribute('data-media-alt') ||
            slide.querySelector('img, video')?.getAttribute('alt') ||
            '';
          const src =
            slide.getAttribute('data-media-src') ||
            slide.querySelector('img')?.getAttribute('src') ||
            slide.querySelector('img')?.getAttribute('data-src') ||
            '';
          const isVideo =
            slide.getAttribute('data-media-is-video') === 'true' ||
            slide.classList.contains('product-media-container--video') ||
            slide.classList.contains('product-media-container--external_video');
          const shopifyPosition = parseInt(slide.getAttribute('data-shopify-position') || '999', 10);
          mediaColor =
            window.ProductCardServices.parseMediaAlt(src, { alt, isVideo, shopifyPosition })
              .normalizedColor || '';
          if (mediaColor) {
            slide.setAttribute('data-media-color', mediaColor);
          }
        }

        mediaColor = normalizeString(mediaColor);

        const matches =
          normalizedColor &&
          mediaColor &&
          mediaColor === normalizedColor;

        if (!matches) {
          slide.style.display = 'none';
          slide.setAttribute('hidden', '');
          slide.setAttribute('aria-hidden', 'true');
          return;
        }

        slide.style.display = '';
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'false');
        visibleCount++;

        // Hydrate first matching slide now; defer the rest (INP).
        if (typeof window.hydrateDeferredProductMedia === 'function') {
          if (!hydratedFirst || isInitialBoot) {
            window.hydrateDeferredProductMedia(slide);
            hydratedFirst = true;
          } else {
            pendingHydrate.push(slide);
          }
        }

        matchingSlides.push(slide);
      });

      matchingSlides.sort(function (a, b) {
        const pa = parseInt(a.getAttribute('data-media-position') || '999', 10) || 999;
        const pb = parseInt(b.getAttribute('data-media-position') || '999', 10) || 999;
        return pa - pb;
      });

      // Reorder only on color switches — boot keeps Liquid order to avoid a flash
      if (!isInitialBoot && slidesContainer && matchingSlides.length) {
        let needsReorder = false;
        const currentVisible = Array.from(slides).filter(function (slide) {
          return slide.style.display !== 'none' && !slide.hasAttribute('hidden');
        });
        if (currentVisible.length !== matchingSlides.length) {
          needsReorder = true;
        } else {
          for (let i = 0; i < matchingSlides.length; i++) {
            if (currentVisible[i] !== matchingSlides[i]) {
              needsReorder = true;
              break;
            }
          }
        }
        if (needsReorder) {
          matchingSlides.forEach(function (slide) {
            slidesContainer.appendChild(slide);
          });
        }
      }

      // Eager-load only when switching colors (boot images already have correct loading attrs)
      if (!isInitialBoot) {
        matchingSlides.forEach(function (slide, index) {
          const img = slide.querySelector('img');
          if (!(img instanceof HTMLImageElement)) return;
          if (img.complete && img.naturalWidth > 0) return;
          img.loading = 'eager';
          if (index === 0) {
            img.fetchPriority = 'high';
          }
        });
      }
    }

    const galleryRoot = mediaGallery.closest('[data-media-gallery-full-width]');
    if (galleryRoot && colorValue) {
      galleryRoot.setAttribute('data-active-media-color', normalizeString(colorValue));
      galleryRoot.dataset.galleryEnableInfinite = 'false';
    }

    mediaGallery.dataset.galleryColorFiltered = normalizedRequested;
    if (isInitialBoot) {
      mediaGallery.dataset.galleryBootFiltered = 'true';
    }

    const runHeavyAfterPaint = function () {
      if (mediaGallery._galleryFilterGen !== filterGen) return;

      if (pendingHydrate.length && typeof window.hydrateDeferredProductMedia === 'function') {
        pendingHydrate.forEach(function (slide) {
          window.hydrateDeferredProductMedia(slide);
        });
      }

      filterZoomMediaByColor(colorValue);

      if (visibleCount > 0 && window.initFullWidthCarousel) {
        // Do not force clone rebuild — init skips clones when visible count is unchanged (INP).
        requestAnimationFrame(function () {
          if (mediaGallery._galleryFilterGen !== filterGen) return;
          window.initFullWidthCarousel(isInitialBoot === true);
          const ctx = getGalleryContext();
          if (ctx?.slideshow) {
            scheduleGalleryVideoAutoplay(ctx.slideshow);
          }
        });
      }
    };

    if (isInitialBoot) {
      // Boot: keep heavy work closer to init so first paint layout is consistent.
      filterZoomMediaByColor(colorValue);
      if (visibleCount > 0 && window.initFullWidthCarousel) {
        requestAnimationFrame(function () {
          window.initFullWidthCarousel(true);
          const ctx = getGalleryContext();
          if (ctx?.slideshow) {
            scheduleGalleryVideoAutoplay(ctx.slideshow);
          }
        });
      }
    } else {
      // Color switch: paint visibility first, then zoom/carousel/video (INP).
      requestAnimationFrame(runHeavyAfterPaint);
    }

    return visibleCount;
  }

  /**
   * Keep zoom dialog media/thumbs in sync with the active alt-text color.
   * @param {string} colorValue
   */
  function filterZoomMediaByColor(colorValue) {
    const section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    const normalizedColor = normalizeString(colorValue || '');
    if (normalizedColor) ensureDeferredColorMedia(normalizedColor);
    const zoomItems = section.querySelectorAll(
      'zoom-dialog .dialog-zoomed-gallery > li[data-media-color], zoom-dialog .dialog-thumbnails-list__thumbnail[data-media-color]'
    );

    zoomItems.forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      const itemColor = normalizeString(item.getAttribute('data-media-color') || '');
      const matches = !normalizedColor || (itemColor && itemColor === normalizedColor);
      if (matches) {
        item.style.display = '';
        item.removeAttribute('hidden');
        if (typeof window.hydrateDeferredProductMedia === 'function') {
          window.hydrateDeferredProductMedia(item);
        }
      } else {
        item.style.display = 'none';
        item.setAttribute('hidden', '');
      }
    });
  }

  /**
   * Hydrate visible deferred shells only.
   * Do NOT warm every other-color URL — that OOM'd tabs on 5+ color PDPs.
   * @param {Element | null} mediaGallery
   */
  function preloadColorLeadImages(mediaGallery) {
    if (!mediaGallery) return;
    const hydrate =
      typeof global.hydrateDeferredProductMedia === 'function'
        ? global.hydrateDeferredProductMedia
        : null;
    if (!hydrate) return;
    mediaGallery.querySelectorAll('slideshow-slide:not([data-gallery-clone])').forEach((slide) => {
      if (!(slide instanceof HTMLElement)) return;
      if (slide.hasAttribute('hidden') || slide.style.display === 'none') return;
      hydrate(slide);
    });
  }

  /**
   * Parse compact other-color map:
   * color::displayUrl::position::id::aspect::alt||...
   * (URLs may contain "://"; fields are peeled from the right.)
   * Zoom/thumb URLs are derived from displayUrl (no extra Liquid image_url).
   * @param {string} raw
   * @returns {Record<string, Array<{u:string,p:number,i:string,z:string,t:string,r:number,alt:string}>>}
   */
  function parsePdpDeferredMediaMap(raw) {
    /** @type {Record<string, Array<{u:string,p:number,i:string,z:string,t:string,r:number,alt:string}>>} */
    const map = {};
    if (!raw) return map;
    let decoded = raw;
    try {
      if (decoded.charAt(0) === '"') decoded = JSON.parse(decoded);
    } catch (e) {
      /* keep raw */
    }

    function withWidth(url, width) {
      if (!url) return '';
      const w = String(width);
      if (/([?&])width=\d+/.test(url)) {
        return url.replace(/([?&])width=\d+/, '$1width=' + w);
      }
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
    }

    for (const row of String(decoded).split('||')) {
      if (!row) continue;
      const colorEnd = row.indexOf('::');
      if (colorEnd < 0) continue;
      const color = row.slice(0, colorEnd);
      let remaining = row.slice(colorEnd + 2);
      const fields = [];
      // Peel alt, aspect, id, position (4 fields). Legacy rows may have 6 (zoom+thumb).
      const peelCount = (remaining.match(/::/g) || []).length >= 6 ? 6 : 4;
      for (let i = 0; i < peelCount; i++) {
        const sep = remaining.lastIndexOf('::');
        if (sep < 0) break;
        fields.unshift(remaining.slice(sep + 2));
        remaining = remaining.slice(0, sep);
      }
      if (!remaining) continue;

      let position;
      let id;
      let zoom;
      let thumb;
      let aspect;
      let alt;
      if (fields.length >= 6) {
        [position, id, zoom, thumb, aspect, alt] = fields;
      } else if (fields.length >= 4) {
        [position, id, aspect, alt] = fields;
        zoom = withWidth(remaining, 1600);
        thumb = withWidth(remaining, 300);
      } else {
        continue;
      }

      if (!map[color]) map[color] = [];
      map[color].push({
        u: remaining,
        p: Number(position) || 1,
        i: String(id || ''),
        z: zoom || withWidth(remaining, 1600),
        t: thumb || withWidth(remaining, 300),
        r: Number(aspect) || 1,
        alt: alt || '',
      });
    }
    Object.keys(map).forEach((color) => {
      map[color].sort((a, b) => a.p - b.p);
    });
    return map;
  }

  /**
   * Inject slideshow + zoom shells for a color from the deferred map (once).
   * Keeps initial HTML = selected color only (Joel-sized) for multi-color products.
   * @param {string} colorValue
   * @returns {boolean}
   */
  function ensureDeferredColorMedia(colorValue) {
    const color = normalizeString(colorValue || '');
    if (!color) return false;

    const galleryRoot = document.querySelector(
      `[data-media-gallery-full-width][data-section-id="${sectionId}"]`
    );
    if (!(galleryRoot instanceof HTMLElement)) return false;

    // Prefer shared helper (media-gallery.js) so PDP + quick-add stay in sync.
    if (typeof global.ensureDeferredColorMediaInRoot === 'function') {
      return Boolean(global.ensureDeferredColorMediaInRoot(galleryRoot, color));
    }

    const existingImages = Array.from(
      galleryRoot.querySelectorAll('slideshow-slide[data-media-color]')
    ).some(function (slide) {
      const isVideo =
        slide.getAttribute('data-media-is-video') === 'true' ||
        slide.classList.contains('product-media-container--video') ||
        slide.classList.contains('product-media-container--external_video');
      return normalizeString(slide.getAttribute('data-media-color') || '') === color && !isVideo;
    });
    if (existingImages) return false;

    const existingMediaIds = new Set(
      Array.from(galleryRoot.querySelectorAll('slideshow-slide[data-media-id]')).map(function (slide) {
        return String(slide.getAttribute('data-media-id') || '');
      })
    );

    if (!galleryRoot._pzDeferredMediaMap) {
      const script = galleryRoot.querySelector('script[data-pdp-deferred-media-map]');
      galleryRoot._pzDeferredMediaMap = parsePdpDeferredMediaMap(script?.textContent || '');
    }
    const entries = galleryRoot._pzDeferredMediaMap[color];
    if (!entries?.length) return false;

    const slideshow = galleryRoot.querySelector('slideshow-slides') ||
      galleryRoot.querySelector('slideshow-component');
    const slidesHost =
      galleryRoot.querySelector('slideshow-slides') ||
      slideshow?.querySelector?.('slideshow-slides');
    if (!(slidesHost instanceof HTMLElement)) return false;

    const pdpSizes = galleryRoot.getAttribute('data-pdp-media-sizes') || '100vw';
    const zoomSizes = galleryRoot.getAttribute('data-zoom-media-sizes') || '100vw';
    const thumbSizes = galleryRoot.getAttribute('data-thumbnail-media-sizes') || '64px';
    const fragment = document.createDocumentFragment();
    const zoomList = galleryRoot.querySelector('zoom-dialog .dialog-zoomed-gallery');
    const zoomThumbs = galleryRoot.querySelector('zoom-dialog .dialog-thumbnails-list');
    const zoomFrag = document.createDocumentFragment();
    const thumbFrag = document.createDocumentFragment();

    entries.forEach((entry, index) => {
      if (existingMediaIds.has(String(entry.i))) return;

      const slide = document.createElement('slideshow-slide');
      slide.className =
        'product-media-container product-media-container--image product-media-container--cover';
      slide.setAttribute('aria-hidden', 'true');
      slide.setAttribute('hidden', '');
      slide.setAttribute('ref', 'slides[]');
      slide.dataset.mediaColor = color;
      slide.dataset.mediaId = entry.i;
      slide.dataset.mediaPosition = String(entry.p);
      slide.dataset.mediaRole = entry.p === 1 ? 'primary' : 'gallery';
      slide.dataset.mediaAlt = entry.alt || `${color}-${entry.p}`;
      slide.dataset.mediaSrc = entry.u;
      slide.dataset.mediaIsVideo = 'false';
      slide.style.setProperty('--media-preview-ratio', String(2 / 3));
      slide.style.setProperty('--product-media-fit', 'cover');

      const shell = document.createElement('div');
      shell.className = 'product-media product-media--deferred';
      shell.style.setProperty('--ratio', String(2 / 3));
      shell.dataset.mediaId = entry.i;
      shell.setAttribute('data-deferred-image', entry.u);
      shell.setAttribute('data-deferred-widths', '400,600,800,1000,1200');
      shell.setAttribute('data-deferred-sizes', pdpSizes);
      shell.setAttribute('data-deferred-alt', entry.alt || '');
      slide.appendChild(shell);
      fragment.appendChild(slide);

      if (zoomList instanceof HTMLElement) {
        const li = document.createElement('li');
        li.id = `product-${entry.i}-deferred-${index}`;
        li.className =
          'product-media-container product-media-container--image product-media-container--cover product-media-container--zoomable';
        li.style.setProperty('--media-preview-ratio', String(2 / 3));
        li.style.display = 'none';
        li.dataset.mediaColor = color;
        li.dataset.mediaId = entry.i;
        li.setAttribute('hidden', '');
        li.setAttribute('ref', 'media[]');
        li.addEventListener('click', function () {
          const dialogEl = galleryRoot.querySelector('zoom-dialog');
          if (dialogEl && typeof dialogEl.close === 'function') dialogEl.close();
        });

        const wrap = document.createElement('drag-zoom-wrapper');
        wrap.className = 'product-media__drag-zoom-wrapper';
        const zShell = document.createElement('div');
        zShell.className = 'product-media product-media--deferred';
        zShell.style.setProperty('--ratio', String(2 / 3));
        zShell.dataset.mediaId = entry.i;
        zShell.setAttribute('data-deferred-image', entry.z || entry.u);
        zShell.setAttribute('data-deferred-widths', '600,800,1000,1200,1600');
        zShell.setAttribute('data-deferred-sizes', zoomSizes);
        zShell.setAttribute('data-deferred-alt', entry.alt || '');
        wrap.appendChild(zShell);
        li.appendChild(wrap);
        zoomFrag.appendChild(li);
      }

      if (zoomThumbs instanceof HTMLElement) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className =
          'button button-unstyled dialog-thumbnails-list__thumbnail dialog-thumbnails-list__thumbnail--deferred';
        btn.style.setProperty('--aspect-ratio', String(2 / 3));
        btn.style.setProperty('--gallery-aspect-ratio', String(2 / 3));
        btn.style.display = 'none';
        btn.dataset.mediaColor = color;
        btn.setAttribute('hidden', '');
        btn.setAttribute('data-deferred-image', entry.t || entry.u);
        btn.setAttribute('data-deferred-alt', entry.alt || '');
        btn.setAttribute('aria-label', entry.alt || color);
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          const dialogEl = galleryRoot.querySelector('zoom-dialog');
          if (!dialogEl || typeof dialogEl.handleThumbnailClick !== 'function') return;
          const buttons = Array.from(zoomThumbs.querySelectorAll('button'));
          dialogEl.handleThumbnailClick(buttons.indexOf(btn));
        });
        thumbFrag.appendChild(btn);
      }
    });

    slidesHost.appendChild(fragment);
    if (zoomList instanceof HTMLElement) zoomList.appendChild(zoomFrag);
    if (zoomThumbs instanceof HTMLElement) zoomThumbs.appendChild(thumbFrag);
    return true;
  }
  
  // Variant picker and buy buttons are now handled by default Shopify components
  // No custom JavaScript needed

  let safeAreaInsetsCache = null;

  function measureSafeAreaInset(edge) {
    if (!safeAreaInsetsCache) {
      safeAreaInsetsCache = { top: 0, right: 0, bottom: 0, left: 0 };

      if (typeof CSS !== 'undefined' && CSS.supports('padding-top: env(safe-area-inset-top)')) {
        const probe = document.createElement('div');
        probe.style.cssText =
          'position:fixed;visibility:hidden;pointer-events:none;inset:0;' +
          'padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) ' +
          'env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px);';
        document.documentElement.appendChild(probe);
        const style = getComputedStyle(probe);
        safeAreaInsetsCache = {
          top: parseFloat(style.paddingTop) || 0,
          right: parseFloat(style.paddingRight) || 0,
          bottom: parseFloat(style.paddingBottom) || 0,
          left: parseFloat(style.paddingLeft) || 0,
        };
        probe.remove();
      }
    }

    return safeAreaInsetsCache[edge] || 0;
  }

  function readCssPx(property, target) {
    const raw = getComputedStyle(target || document.body).getPropertyValue(property).trim();
    const value = parseFloat(raw);
    return Number.isNaN(value) ? 0 : value;
  }

  function getHeaderChromeBottomPx() {
    const headerGroup = document.querySelector('#header-group');
    const header = document.querySelector('#header-component');
    let chromeBottom = 0;

    if (headerGroup) {
      const children = headerGroup.children;
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (!(child instanceof HTMLElement)) continue;

        const rect = child.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > chromeBottom) {
          chromeBottom = rect.bottom;
        }
      }
    }

    if (chromeBottom > 0) {
      return chromeBottom;
    }

    if (header) {
      return header.getBoundingClientRect().bottom;
    }

    return (
      readCssPx('--header-group-height', document.body) ||
      readCssPx('--header-height', document.body)
    );
  }

  function getAvailableGalleryHeightPx(parentMedia) {
    const visualViewport = window.visualViewport;
    const viewportHeight = visualViewport ? visualViewport.height : window.innerHeight;
    const viewportTop = visualViewport ? visualViewport.offsetTop : 0;
    const safeTop = measureSafeAreaInset('top');
    const safeBottom = measureSafeAreaInset('bottom');

    let contentTop = getHeaderChromeBottomPx();

    if (parentMedia) {
      const mediaTop = parentMedia.getBoundingClientRect().top;
      if (mediaTop > 0) {
        contentTop = Math.max(contentTop, mediaTop);
      }
    }

    const topWithinVisualViewport = Math.max(contentTop - viewportTop, safeTop);
    const available = viewportHeight - topWithinVisualViewport - safeBottom;

    return Math.max(200, Math.floor(available));
  }

  function getGalleryHeightPx(parentMedia) {
    return getAvailableGalleryHeightPx(parentMedia);
  }

  function lockGalleryHeight(parentMedia) {
    if (!parentMedia) return 0;

    const locked = parentMedia.dataset.galleryHeightLocked === 'true'
      ? parseFloat(parentMedia.style.getPropertyValue('--pdp-gallery-height')) || 0
      : 0;

    if (locked > 0) {
      parentMedia.style.setProperty('--pdp-mobile-gallery-height', locked + 'px');
      document.documentElement.style.setProperty('--pdp-available-media-height', locked + 'px');
      return locked;
    }

    const measured = getGalleryHeightPx(parentMedia);
    // Prefer the already-painted CSS height when it matches (avoids load flash).
    const painted = Math.round(parentMedia.getBoundingClientRect().height);
    const availableHeight =
      painted > 100 && Math.abs(painted - measured) <= 12 ? painted : measured;

    parentMedia.dataset.galleryHeightLocked = 'true';
    parentMedia.style.setProperty('--pdp-gallery-height', availableHeight + 'px');
    parentMedia.style.setProperty('--pdp-mobile-gallery-height', availableHeight + 'px');
    document.documentElement.style.setProperty('--pdp-available-media-height', availableHeight + 'px');
    return availableHeight;
  }

  function clearMobileGalleryFrame(parentMedia) {
    if (!parentMedia) return;
    parentMedia.classList.remove('product-information__media--height-capped');
    parentMedia.style.removeProperty('--pdp-mobile-gallery-max-height');
    parentMedia.style.removeProperty('--pdp-mobile-gallery-height');
    parentMedia.style.removeProperty('--pdp-available-media-height');
    parentMedia.style.removeProperty('height');
    parentMedia.style.removeProperty('max-height');
    parentMedia.style.removeProperty('width');
    parentMedia.style.removeProperty('max-width');
    parentMedia.style.removeProperty('margin-left');
    parentMedia.style.removeProperty('margin-right');
    parentMedia.style.removeProperty('aspect-ratio');
  }

  function syncMobileGalleryHeight(parentMedia) {
    if (!parentMedia || !isPhoneGalleryView(parentMedia)) return;

    const containerWidth = parentMedia.getBoundingClientRect().width || window.innerWidth;
    if (containerWidth <= 0) return;

    // Fixed full-width 2:3 frame on phone (no viewport shrink).
    const aspectRatio = 2 / 3;
    const galleryHeight = Math.ceil(containerWidth / aspectRatio);

    parentMedia.classList.remove('product-information__media--height-capped');
    parentMedia.style.removeProperty('--pdp-mobile-gallery-max-height');
    parentMedia.style.removeProperty('--pdp-available-media-height');
    parentMedia.style.removeProperty('max-height');
    parentMedia.style.removeProperty('width');
    parentMedia.style.removeProperty('max-width');
    parentMedia.style.removeProperty('margin-left');
    parentMedia.style.removeProperty('margin-right');
    parentMedia.style.setProperty('--media-preview-ratio', String(aspectRatio));
    parentMedia.style.setProperty('--pdp-mobile-gallery-aspect', '2 / 3');
    parentMedia.style.setProperty('--pdp-mobile-gallery-height', galleryHeight + 'px');
    parentMedia.style.height = galleryHeight + 'px';
    parentMedia.style.aspectRatio = '2 / 3';
  }

  function getSlideAspectRatio(slide) {
    // PDP gallery uses a fixed 2:3 frame for consistent slide sizing.
    if (isPhoneGalleryViewport()) return 2 / 3;

    if (!slide) return 2 / 3;

    const style = getComputedStyle(slide);
    const fromVar = parseFloat(style.getPropertyValue('--media-preview-ratio'));
    if (!Number.isNaN(fromVar) && fromVar > 0) {
      return fromVar;
    }

    return 2 / 3;
  }

  function resolveAutoMediaColumns(parentMedia, gap) {
    const containerWidth = parentMedia.getBoundingClientRect().width;
    const galleryHeight = getGalleryHeightPx(parentMedia);

    if (containerWidth <= 0) return 1;

    const slides = Array.from(parentMedia.querySelectorAll('slideshow-slide')).filter(function(slide) {
      return slide.style.display !== 'none' && !slide.hasAttribute('hidden');
    });

    if (slides.length === 0) return 1;

    let usedWidth = 0;
    let count = 0;
    const maxCols = 4;

    for (let i = 0; i < slides.length && count < maxCols; i++) {
      const slideWidth = galleryHeight * getSlideAspectRatio(slides[i]);
      const nextWidth = usedWidth + (count > 0 ? gap : 0) + slideWidth;

      if (nextWidth > containerWidth && count > 0) {
        break;
      }

      usedWidth = nextWidth;
      count++;
    }

    return Math.max(1, count);
  }

  function getConfiguredMediaColumns(parentMedia) {
    if (!parentMedia) return 1;
    const gap = getConfiguredMediaGap(parentMedia);
    return resolveAutoMediaColumns(parentMedia, gap);
  }

  function getConfiguredMediaGap(parentMedia) {
    if (!parentMedia) return 0;

    const fromData = parseInt(parentMedia.dataset.fullWidthMediaGap, 10);
    if (!Number.isNaN(fromData) && fromData >= 0) {
      return fromData;
    }

    return 0;
  }

  function isPhoneGalleryView(parentMedia) {
    if (isPhoneGalleryViewport()) return true;

    if (parentMedia) {
      const mediaWidth = parentMedia.getBoundingClientRect().width;
      if (mediaWidth > 0 && mediaWidth <= PRODUCT_GALLERY_PHONE_MAX) return true;
    }

    return false;
  }

  function syncMediaColumnLayout(parentMedia, slidesContainer, configuredColumns, gap) {
    const isPhone = isPhoneGalleryView(parentMedia);

    parentMedia.classList.toggle('product-information__media--single-column-preview', isPhone);
    parentMedia.classList.toggle('product-information__media--columns-auto', !isPhone);
    parentMedia.classList.toggle('product-information__media--height-led', !isPhone);

    if (isPhone) {
      parentMedia.classList.remove('product-information__media--height-led');
      // Full-bleed single column — no side peek (peek left gutters / non-full-width slides).
      parentMedia.classList.remove('product-information__media--swipe-peek');
      parentMedia.classList.add('product-information__media--single-column-preview');
      parentMedia.style.setProperty('--full-width-media-columns', '1');
      const gapPx = '0px';
      parentMedia.style.setProperty('--full-width-media-gap', gapPx);
      parentMedia.classList.add('product-information__media--gallery-gap-zero');
      slidesContainer.style.setProperty('--slides-per-view', '1');
      slidesContainer.style.setProperty('--slide-gap', gapPx);
      slidesContainer.style.setProperty('--slideshow-gap', gapPx);
      slidesContainer.style.gap = gapPx;
      slidesContainer.style.paddingInline = '0';
      slidesContainer.style.scrollPaddingInline = '0';
      parentMedia.style.removeProperty('--pdp-gallery-height');
      document.documentElement.style.removeProperty('--pdp-available-media-height');
      syncMobileGalleryHeight(parentMedia);
      return { isPhoneGallery: true, columns: 1 };
    }

    clearMobileGalleryFrame(parentMedia);
    parentMedia.classList.remove('product-information__media--swipe-peek');
    parentMedia.classList.toggle('product-information__media--gallery-gap-zero', gap === 0);
    parentMedia.style.setProperty('--full-width-media-columns', String(configuredColumns));
    parentMedia.style.setProperty('--full-width-media-gap', gap + 'px');
    lockGalleryHeight(parentMedia);
    slidesContainer.style.removeProperty('--slides-per-view');
    slidesContainer.style.setProperty('--slide-gap', gap + 'px');
    slidesContainer.style.setProperty('--slideshow-gap', gap + 'px');

    return { isPhoneGallery: false, columns: configuredColumns };
  }

  function resetDesktopSlideSizing(slides) {
    slides.forEach(function(slide) {
      slide.style.removeProperty('flex');
      slide.style.removeProperty('max-width');
      slide.style.removeProperty('width');
    });
  }

  function observeGalleryViewportChrome() {
    if (window._pdpGalleryViewportObserversInit) return;
    window._pdpGalleryViewportObserversInit = true;

    const refresh = function() {
      scheduleCarouselRefresh();
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', refresh);
    }

    const headerGroup = document.querySelector('#header-group');
    if (headerGroup) {
      const chromeObserver = new ResizeObserver(refresh);
      for (let i = 0; i < headerGroup.children.length; i++) {
        const child = headerGroup.children[i];
        if (child instanceof HTMLElement) {
          chromeObserver.observe(child);
        }
      }
    }
  }

  function getGalleryContext() {
    const carouselWrapper = document.querySelector('.media-gallery__carousel-wrapper[data-section-id="' + sectionId + '"]');
    if (!carouselWrapper) return null;

    const parentMedia = carouselWrapper.closest('.product-information__media');
    const slideshow = carouselWrapper.querySelector('slideshow-component');
    const slidesContainer = slideshow?.querySelector('slideshow-slides');

    if (!slideshow || !slidesContainer || !parentMedia) return null;

    return { carouselWrapper, parentMedia, slideshow, slidesContainer };
  }

  function getVisibleSlidesFromSlideshow(slideshow) {
    return Array.from(slideshow.querySelectorAll('slideshow-slide')).filter(function(slide) {
      return (
        slide.style.display !== 'none' &&
        !slide.hasAttribute('hidden') &&
        !slide.hasAttribute('data-gallery-clone')
      );
    });
  }

  /**
   * Place gallery at first real media instantly — no smooth scroll, no pagination flicker.
   * @param {HTMLElement} slideshow
   */
  function settleGalleryAtStart(slideshow) {
    if (!slideshow) return;

    const slidesContainer = slideshow.querySelector('slideshow-slides');
    if (!slidesContainer) return;

    const visibleSlides = getVisibleSlidesFromSlideshow(slideshow);
    if (visibleSlides.length === 0) return;

    const firstSlide = visibleSlides[0];
    const getVisibleSlides = function () {
      return getVisibleSlidesFromSlideshow(slideshow);
    };

    slidesContainer._gallerySettling = true;

    const prevBehavior = slidesContainer.style.scrollBehavior;
    const prevSnap = slidesContainer.style.scrollSnapType;
    slidesContainer.style.scrollBehavior = 'auto';
    slidesContainer.style.scrollSnapType = 'none';

    // Instantly park at first visible media (respects its layout position)
    slidesContainer.scrollLeft = firstSlide.offsetLeft || 0;

    // Index among visible/navigable slides — always start at first
    slideshow.current = 0;

    // Keep first pagination control selected without interim switches
    updateDesktopPaginationUI(slideshow, slidesContainer, getVisibleSlides);

    const dots = slideshow.refs?.dots;
    if (dots?.length) {
      dots.forEach(function(dot, index) {
        dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      });
    }

    updateGalleryArrowState(slideshow, slidesContainer, getVisibleSlides);

    requestAnimationFrame(function() {
      slidesContainer.scrollLeft = firstSlide.offsetLeft || 0;
      slidesContainer.style.scrollBehavior = prevBehavior;
      slidesContainer.style.scrollSnapType = prevSnap;
      slidesContainer._gallerySettling = false;
      updateDesktopPaginationUI(slideshow, slidesContainer, getVisibleSlides);
      // Re-apply after slideshow.current setter (it uses wrong multi-column nextIndex)
      updateGalleryArrowState(slideshow, slidesContainer, getVisibleSlides);
    });
  }

  /**
   * Resolve prev/next arrow buttons (refs may miss nested slideshow-arrows).
   * @param {HTMLElement} slideshow
   * @returns {{ previous: HTMLButtonElement | null, next: HTMLButtonElement | null }}
   */
  function getGalleryArrowButtons(slideshow) {
    const previous =
      (slideshow.refs?.previous instanceof HTMLButtonElement && slideshow.refs.previous) ||
      slideshow.querySelector(
        'slideshow-arrows .slideshow-control--previous, .slideshow-control--previous'
      );
    const next =
      (slideshow.refs?.next instanceof HTMLButtonElement && slideshow.refs.next) ||
      slideshow.querySelector(
        'slideshow-arrows .slideshow-control--next, .slideshow-control--next'
      );

    return {
      previous: previous instanceof HTMLButtonElement ? previous : null,
      next: next instanceof HTMLButtonElement ? next : null,
    };
  }

  /**
   * Apply disabled / enabled state to a gallery arrow control.
   * @param {HTMLButtonElement | null} button
   * @param {boolean} disabled
   */
  function setGalleryArrowDisabled(button, disabled) {
    if (!button) return;
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    button.classList.toggle('is-disabled', disabled);
    if (disabled) {
      button.setAttribute('disabled', '');
    } else {
      button.removeAttribute('disabled');
    }
  }

  /**
   * Prev/Next: enable/disable from leading media index (one-media navigation).
   * Next disables at last filled stop so the trailing edge never shows blank.
   */
  function updateGalleryArrowState(slideshow, slidesContainer, getVisibleSlides) {
    if (!slideshow) return;

    const { previous, next } = getGalleryArrowButtons(slideshow);
    if (!previous && !next) return;

    let visibleSlides = [];
    try {
      visibleSlides =
        typeof getVisibleSlides === 'function'
          ? dedupeSlidesByMediaId(getVisibleSlides())
          : getVisibleSlidesFromSlideshow(slideshow);
    } catch (e) {
      visibleSlides = getVisibleSlidesFromSlideshow(slideshow);
    }
    const total = visibleSlides.length;

    if (total <= 1) {
      setGalleryArrowDisabled(previous, true);
      setGalleryArrowDisabled(next, true);
      return;
    }

    const parentMedia = slideshow.closest('.product-information__media');
    const stops = getGalleryScrollStops(parentMedia, total);

    const leadingIndex = Math.max(
      0,
      slidesContainer
        ? getLeadingRealIndex(slideshow, slidesContainer, function () {
            return visibleSlides;
          })
        : slideshow.current || 0
    );

    setGalleryArrowDisabled(previous, leadingIndex <= 0);
    setGalleryArrowDisabled(next, leadingIndex >= stops.lastPageStartIndex);
  }

  function refreshGalleryLayout() {
    const ctx = getGalleryContext();
    if (!ctx) return;

    const configuredColumns = getConfiguredMediaColumns(ctx.parentMedia);
    const configuredGap = getConfiguredMediaGap(ctx.parentMedia);
    syncMediaColumnLayout(ctx.parentMedia, ctx.slidesContainer, configuredColumns, configuredGap);

    const visibleSlides = getVisibleSlidesFromSlideshow(ctx.slideshow);
    const getVisibleSlides = function () {
      return visibleSlides;
    };
    ensureGalleryScrollEndSpacer(ctx.parentMedia, ctx.slidesContainer, getVisibleSlides);
    updateDesktopPaginationUI(ctx.slideshow, ctx.slidesContainer, getVisibleSlides);
    updateGalleryArrowState(ctx.slideshow, ctx.slidesContainer, getVisibleSlides);
  }

  function observeMobilePdpContent() {
    const section = document.getElementById('shopify-section-' + sectionId);
    if (!section || section._mobilePdpLayoutObserverInit) return;
    section._mobilePdpLayoutObserverInit = true;

    const targets = [
      section.querySelector('.breadcrumbs--product'),
      section.querySelector('.product-details__info--mobile-hero'),
      section.querySelector('.product-details__info--mobile-purchase'),
    ].filter(function(el) {
      return el instanceof HTMLElement;
    });

    if (targets.length === 0) return;

    const observer = new ResizeObserver(function() {
      scheduleCarouselRefresh();
    });

    targets.forEach(function(el) {
      observer.observe(el);
    });
  }

  function observeProductMediaLayout() {
    const section = document.getElementById('shopify-section-' + sectionId);
    const parentMedia = section?.querySelector('.product-information__media--full-width');
    if (!parentMedia || parentMedia._layoutResizeObserver) return;

    parentMedia._layoutResizeObserver = new ResizeObserver(function() {
      scheduleCarouselRefresh();
    });
    parentMedia._layoutResizeObserver.observe(parentMedia);
  }

  function getLeadingSlideElement(slideshow, slidesContainer) {
    // Include clones so infinite-loop positions resolve to the on-screen slide,
    // then getLeadingRealIndex maps clone-of → real index.
    const slides = Array.from(slidesContainer.querySelectorAll('slideshow-slide')).filter(function(slide) {
      return slide.style.display !== 'none' && !slide.hasAttribute('hidden');
    });
    if (slides.length === 0) return null;

    const scrollLeft = slidesContainer.scrollLeft;
    let leadingSlide = slides[0];
    let bestDistance = Infinity;

    slides.forEach(function(slide) {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < bestDistance) {
        bestDistance = distance;
        leadingSlide = slide;
      }
    });

    return leadingSlide;
  }

  function getLeadingSlideIndex(slideshow, slidesContainer, getVisibleSlides) {
    const leadingSlide = getLeadingSlideElement(slideshow, slidesContainer);
    if (!leadingSlide) return -1;

    const allSlides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    return allSlides.indexOf(leadingSlide);
  }

  function getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides) {
    const leadingSlide = getLeadingSlideElement(slideshow, slidesContainer);
    if (!leadingSlide) return -1;

    if (leadingSlide.hasAttribute('data-gallery-clone')) {
      const cloneIndex = parseInt(leadingSlide.getAttribute('data-gallery-clone-of'), 10);
      return Number.isNaN(cloneIndex) ? -1 : cloneIndex;
    }

    const visibleSlides = getVisibleSlides();
    return visibleSlides.indexOf(leadingSlide);
  }

  function usesGalleryInfiniteLoop(parentMedia, slideshow, getVisibleSlides) {
    if (!slideshow.infinite || !parentMedia || isPhoneGalleryView(parentMedia)) {
      return false;
    }

    const visibleSlides = dedupeSlidesByMediaId(getVisibleSlides());
    const columns = getGalleryColumnsOnDisplay(parentMedia);
    if (visibleSlides.length <= 1 || visibleSlides.length <= columns) {
      return false;
    }

    const pagination = getDesktopPaginationState(0, visibleSlides.length, columns, true);
    return pagination.pageCount > 1;
  }

  function removeGalleryClones(slidesContainer) {
    slidesContainer.querySelectorAll('[data-gallery-clone]').forEach(function(clone) {
      clone.remove();
    });
  }

  function cloneGallerySlide(slide, index, position) {
    const clone = slide.cloneNode(true);
    clone.setAttribute('data-gallery-clone', position);
    clone.setAttribute('data-gallery-clone-of', String(index));
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('ref');
    clone.querySelectorAll('[id]').forEach(function(element) {
      element.removeAttribute('id');
    });
    return clone;
  }

  function getGalleryRealTrackMetrics(slidesContainer, getVisibleSlides) {
    const realSlides = getVisibleSlides();
    if (realSlides.length === 0) return null;

    const firstReal = realSlides[0];
    const tailClone = slidesContainer.querySelector('[data-gallery-clone="tail"]');
    const firstRealLeft = firstReal.offsetLeft;
    const trackWidth = tailClone
      ? tailClone.offsetLeft - firstRealLeft
      : realSlides[realSlides.length - 1].offsetLeft +
        realSlides[realSlides.length - 1].offsetWidth -
        firstRealLeft;

    return {
      realSlides,
      firstReal,
      firstRealLeft,
      trackWidth,
      tailStart: tailClone ? tailClone.offsetLeft : Infinity,
    };
  }

  function normalizeGalleryInfiniteScroll(slideshow, slidesContainer, getVisibleSlides) {
    if (slideshow._galleryNormalizingScroll) return;

    const metrics = getGalleryRealTrackMetrics(slidesContainer, getVisibleSlides);
    if (!metrics || metrics.trackWidth <= 0) return;

    const tolerance = 4;
    const scrollLeft = slidesContainer.scrollLeft;
    let nextLeft = null;

    if (scrollLeft >= metrics.tailStart - tolerance) {
      nextLeft = scrollLeft - metrics.trackWidth;
    } else if (scrollLeft < metrics.firstRealLeft - tolerance) {
      nextLeft = scrollLeft + metrics.trackWidth;
    }

    if (nextLeft == null) return;

    // Must be instant — CSS `scroll-behavior: smooth` would animate this jump
    // backward and look like a rewind to the first slide.
    slideshow._galleryNormalizingScroll = true;
    const prevBehavior = slidesContainer.style.scrollBehavior;
    const prevSnap = slidesContainer.style.scrollSnapType;
    slidesContainer.style.scrollBehavior = 'auto';
    slidesContainer.style.scrollSnapType = 'none';
    slidesContainer.scrollLeft = nextLeft;
    requestAnimationFrame(function() {
      slidesContainer.style.scrollBehavior = prevBehavior;
      slidesContainer.style.scrollSnapType = prevSnap;
      slideshow._galleryNormalizingScroll = false;
    });
  }

  function scrollGalleryToRealIndex(slideshow, slidesContainer, getVisibleSlides, realIndex, options) {
    const realSlides = getVisibleSlides();
    const total = realSlides.length;
    if (total === 0) return;

    const parentMedia = slideshow.closest('.product-information__media');
    const stops = getGalleryScrollStops(parentMedia, total);
    // Clamp to last filled stop — last N cards stay on screen (no blank edge)
    const target = Math.max(0, Math.min(stops.lastPageStartIndex, realIndex));
    const animate = !options || options.animate !== false;
    const targetEl = realSlides[target];
    if (!targetEl) return;

    const prevBehavior = slidesContainer.style.scrollBehavior;
    if (!animate) {
      slidesContainer.style.scrollBehavior = 'auto';
    }

    slidesContainer.scrollTo({
      left: targetEl.offsetLeft,
      behavior: animate ? 'smooth' : 'auto',
    });

    if (!animate) {
      slidesContainer.style.scrollBehavior = prevBehavior;
    }

    slideshow.current = target;
    updateDesktopPaginationUI(slideshow, slidesContainer, getVisibleSlides);
    updateGalleryArrowState(slideshow, slidesContainer, getVisibleSlides);
  }

  function setupGalleryInfiniteClones(slideshow, slidesContainer, parentMedia, getVisibleSlides) {
    removeGalleryClones(slidesContainer);

    const spacer = slidesContainer.querySelector('[data-gallery-scroll-spacer]');
    if (spacer) spacer.remove();

    if (!usesGalleryInfiniteLoop(parentMedia, slideshow, getVisibleSlides)) {
      ensureGalleryScrollEndSpacer(parentMedia, slidesContainer, getVisibleSlides);
      return;
    }

    const realSlides = getVisibleSlides();
    if (realSlides.length <= 1) return;

    const columns = getGalleryColumnsOnDisplay(parentMedia);
    const pageCount = getDesktopPaginationState(0, realSlides.length, columns, false).pageCount;
    if (pageCount <= 1) return;

    const savedRealLeading = Math.max(0, getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides));

    realSlides.forEach(function(slide, index) {
      slidesContainer.appendChild(cloneGallerySlide(slide, index, 'tail'));
    });

    for (let index = realSlides.length - 1; index >= 0; index--) {
      slidesContainer.insertBefore(cloneGallerySlide(realSlides[index], index, 'head'), realSlides[0]);
    }

    scrollGalleryToRealIndex(slideshow, slidesContainer, getVisibleSlides, savedRealLeading, { animate: false });
  }

  function isGalleryAtScrollEnd(slidesContainer) {
    const maxScroll = Math.max(0, slidesContainer.scrollWidth - slidesContainer.clientWidth);
    return maxScroll <= 1 || slidesContainer.scrollLeft >= maxScroll - 3;
  }

  function isGalleryAtScrollStart(slidesContainer) {
    return slidesContainer.scrollLeft <= 3;
  }

  function canAdvanceGalleryForward(slideshow, slidesContainer, getVisibleSlides) {
    const visibleSlides = getVisibleSlides();
    if (visibleSlides.length <= 1) return false;

    const leadingIndex = getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides);
    if (leadingIndex < 0) return false;

    const parentMedia = slideshow.closest('.product-information__media');
    const stops = getGalleryScrollStops(parentMedia, visibleSlides.length);
    return leadingIndex < stops.lastPageStartIndex;
  }

  function canRetreatGalleryBackward(slideshow, slidesContainer, getVisibleSlides) {
    const visibleSlides = getVisibleSlides();
    if (visibleSlides.length <= 1) return false;

    const leadingIndex = getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides);
    if (leadingIndex < 0) return false;

    return leadingIndex > 0;
  }

  function shouldWrapGalleryForward(slideshow, slidesContainer, getVisibleSlides) {
    if (canAdvanceGalleryForward(slideshow, slidesContainer, getVisibleSlides)) return false;

    const visibleSlides = getVisibleSlides();
    const leadingIndex = getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides);
    if (leadingIndex < 0) return false;

    const lastVisible = visibleSlides[visibleSlides.length - 1];
    const leadingSlide = visibleSlides[leadingIndex];

    return leadingSlide === lastVisible || isGalleryAtScrollEnd(slidesContainer);
  }

  function shouldWrapGalleryBackward(slideshow, slidesContainer, getVisibleSlides) {
    if (canRetreatGalleryBackward(slideshow, slidesContainer, getVisibleSlides)) return false;

    const visibleSlides = getVisibleSlides();
    const leadingIndex = getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides);
    if (leadingIndex < 0) return false;

    const leadingSlide = visibleSlides[leadingIndex];
    const firstVisible = visibleSlides[0];

    return leadingSlide === firstVisible && isGalleryAtScrollStart(slidesContainer);
  }

  function getGalleryColumnsOnDisplay(parentMedia) {
    const fromInline = parseInt(parentMedia.style.getPropertyValue('--full-width-media-columns'), 10);
    if (!Number.isNaN(fromInline) && fromInline > 0) return fromInline;

    const fromComputed = parseInt(
      getComputedStyle(parentMedia).getPropertyValue('--full-width-media-columns'),
      10
    );
    if (!Number.isNaN(fromComputed) && fromComputed > 0) return fromComputed;

    return resolveAutoMediaColumns(parentMedia, getConfiguredMediaGap(parentMedia));
  }

  /**
   * Scroll stops for one-by-one nav with a filled viewport.
   * Example: 7 media, 3 on screen → 5 stops (0..4); last stop keeps 3 media on screen.
   */
  function getGalleryScrollStops(parentMedia, totalSlides) {
    let columns = 1;
    if (parentMedia && !isPhoneGalleryView(parentMedia)) {
      columns = Math.max(1, getGalleryColumnsOnDisplay(parentMedia));
    }
    const lastPageStartIndex = Math.max(0, totalSlides - columns);
    const pageCount = Math.max(1, totalSlides - columns + 1);
    return { columns, lastPageStartIndex, pageCount };
  }

  function getDesktopPaginationState(leadingIndex, totalSlides, columnsOnDisplay, isInfinite) {
    // Used for scroll-end / spacer math when multiple columns are visible.
    const pageCount = Math.max(1, totalSlides - columnsOnDisplay + 1);
    const lastPageStartIndex = Math.max(0, totalSlides - columnsOnDisplay);

    if (pageCount === 1) {
      return { pageCount: 1, currentPage: 1, lastPageStartIndex: 0 };
    }

    let currentPage = Math.min(Math.max(1, leadingIndex + 1), pageCount);
    if (leadingIndex >= lastPageStartIndex) {
      currentPage = pageCount;
    }

    return { pageCount, currentPage, lastPageStartIndex };
  }

  function getFirstVisibleSlideWidth(slidesContainer) {
    if (!slidesContainer) return 0;

    const slides = Array.from(slidesContainer.querySelectorAll('slideshow-slide')).filter(function(slide) {
      if (slide.hasAttribute('data-gallery-clone')) return false;
      if (slide.hasAttribute('hidden')) return false;
      if (slide.style.display === 'none') return false;
      return true;
    });

    const first = slides[0];
    if (first instanceof HTMLElement && first.offsetWidth > 0) {
      return first.offsetWidth;
    }

    return slidesContainer.clientWidth;
  }

  function scheduleGalleryScrollProgress(slideshow, slidesContainer) {
    if (!slideshow || !slidesContainer) return;

    if (slidesContainer._galleryProgressRaf) return;
    slidesContainer._galleryProgressRaf = window.requestAnimationFrame(function() {
      slidesContainer._galleryProgressRaf = 0;
      updateGalleryScrollProgress(slideshow, slidesContainer);
    });
  }

  function updateGalleryScrollProgress(slideshow, slidesContainer) {
    if (!slideshow || !slidesContainer) return;

    const wrapper = slideshow.closest('.media-gallery__carousel-wrapper');
    if (!wrapper) return;

    const progressRoot = wrapper.querySelector('.media-gallery__scroll-progress');
    const fill = wrapper.querySelector('[data-gallery-scroll-progress-fill]');
    if (!progressRoot || !fill) return;

    const scrollWidth = slidesContainer.scrollWidth;
    const clientWidth = slidesContainer.clientWidth;

    if (scrollWidth <= clientWidth + 1) {
      progressRoot.hidden = true;
      fill.style.width = '100%';
      return;
    }

    progressRoot.hidden = false;

    const firstSlideWidth = getFirstVisibleSlideWidth(slidesContainer);
    const minPercent = Math.min(100, (firstSlideWidth / scrollWidth) * 100);
    const maxScroll = Math.max(0, scrollWidth - clientWidth);
    let scrollRatio = 1;

    if (maxScroll > 0) {
      scrollRatio = Math.min(1, Math.max(0, slidesContainer.scrollLeft / maxScroll));
    }

    const percent = minPercent + (100 - minPercent) * scrollRatio;
    fill.style.width = percent + '%';
  }

  function updateDesktopPaginationUI(slideshow, slidesContainer, getVisibleSlides) {
    const parentMedia = slideshow.closest('.product-information__media');
    const controls = slideshow.querySelector('slideshow-controls');
    const dots = slideshow.refs?.dots;
    const counterCurrent = slideshow.refs?.current;
    const counterTotal = slideshow.refs?.total;
    const visibleSlides = dedupeSlidesByMediaId(getVisibleSlides());
    const total = visibleSlides.length;

    updateGalleryScrollProgress(slideshow, slidesContainer);

    if (controls) {
      controls.toggleAttribute('hidden', total <= 1);
    }

    if (!controls || total <= 1) return;

    // Option A: one mark per scroll stop (total - columns + 1)
    const leadingIndex = Math.max(0, getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides));
    const stops = getGalleryScrollStops(parentMedia, total);
    const activeIndex = Math.min(leadingIndex, stops.lastPageStartIndex);

    if (dots?.length) {
      dots.forEach((dot, index) => {
        const listItem = dot.closest('li');
        const isVisible = index < stops.pageCount;

        if (listItem) listItem.style.display = isVisible ? '' : 'none';
        dot.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
      });
    }

    if (counterCurrent) {
      counterCurrent.textContent = String(activeIndex + 1);
    }
    if (counterTotal) {
      counterTotal.textContent = String(stops.pageCount);
    }
  }

  function setupDesktopPaginationControls(slideshow, slidesContainer, getVisibleSlides) {
    const controls = slideshow.querySelector('slideshow-controls');
    if (!controls || controls._desktopPaginationClickInit) return;
    controls._desktopPaginationClickInit = true;

    controls.addEventListener(
      'click',
      function(event) {
        const parentMedia = slideshow.closest('.product-information__media');
        if (!parentMedia) return;

        const button = event.target.closest('.slideshow-controls__dots button, .slideshow-control--line');
        if (!button || !slideshow.refs?.dots?.includes(button)) return;

        const visibleSlides = getVisibleSlides();
        const stops = getGalleryScrollStops(parentMedia, visibleSlides.length);
        const dotIndex = slideshow.refs.dots.indexOf(button);
        if (dotIndex < 0 || dotIndex >= stops.pageCount) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        // Dot index === leading stop index (clamped so end stays filled)
        scrollGalleryToRealIndex(slideshow, slidesContainer, getVisibleSlides, dotIndex, {
          animate: true,
        });
      },
      true
    );
  }

  /**
   * Max scrollLeft so the last N media fill the viewport (no trailing blank).
   * @param {HTMLElement | null} parentMedia
   * @param {HTMLElement} slidesContainer
   * @param {() => HTMLElement[]} getVisibleSlides
   * @returns {number}
   */
  function getGalleryFilledEndScrollLeft(parentMedia, slidesContainer, getVisibleSlides) {
    const visibleSlides = getVisibleSlides();
    if (!visibleSlides.length) return 0;

    const stops = getGalleryScrollStops(parentMedia, visibleSlides.length);
    const endSlide = visibleSlides[stops.lastPageStartIndex];
    if (!endSlide) return 0;

    return Math.max(0, endSlide.offsetLeft || 0);
  }

  /**
   * Clamp trackpad/touch scroll so it cannot pass the last filled stop.
   * @returns {boolean} true when scroll position was corrected
   */
  function clampGalleryScrollToFilledEnd(slideshow, slidesContainer, getVisibleSlides) {
    if (!slidesContainer || slidesContainer._gallerySettling) return false;
    if (slideshow?._galleryNormalizingScroll) return false;

    const parentMedia = slideshow?.closest?.('.product-information__media');
    if (!parentMedia || usesGalleryInfiniteLoop(parentMedia, slideshow, getVisibleSlides)) {
      return false;
    }

    const maxLeft = getGalleryFilledEndScrollLeft(parentMedia, slidesContainer, getVisibleSlides);
    if (slidesContainer.scrollLeft <= maxLeft + 1) return false;

    const prevBehavior = slidesContainer.style.scrollBehavior;
    const prevSnap = slidesContainer.style.scrollSnapType;
    slidesContainer.style.scrollBehavior = 'auto';
    slidesContainer.style.scrollSnapType = 'none';
    slidesContainer.scrollLeft = maxLeft;
    // Restore snap on next frame so momentum cannot re-open blank space
    requestAnimationFrame(function () {
      slidesContainer.style.scrollBehavior = prevBehavior;
      slidesContainer.style.scrollSnapType = prevSnap;
      if (slidesContainer.scrollLeft > maxLeft + 1) {
        slidesContainer.scrollLeft = maxLeft;
      }
    });
    return true;
  }

  function syncLeadingPagination(slideshow, slidesContainer, getVisibleSlides, options) {
    if (slidesContainer._leadingPaginationRaf) return;
    // Skip while landing/settling — prevents pagination line flicker
    if (slidesContainer._gallerySettling) return;

    const shouldNormalize = options && options.normalize === true;

    slidesContainer._leadingPaginationRaf = window.requestAnimationFrame(function() {
      slidesContainer._leadingPaginationRaf = 0;
      if (slidesContainer._gallerySettling) return;

      const parentMedia = slideshow.closest('.product-information__media');
      const visibleSlides = getVisibleSlides();
      const stops = getGalleryScrollStops(parentMedia, visibleSlides.length);

      // Trackpad/touch: hard-stop at last filled viewport (last N media on screen)
      const clamped = clampGalleryScrollToFilledEnd(slideshow, slidesContainer, getVisibleSlides);

      let realLeading = getLeadingRealIndex(slideshow, slidesContainer, getVisibleSlides);

      // If swipe still overshoots past the filled end, snap back (no blank edge)
      if ((shouldNormalize || clamped) && realLeading > stops.lastPageStartIndex) {
        scrollGalleryToRealIndex(slideshow, slidesContainer, getVisibleSlides, stops.lastPageStartIndex, {
          animate: false,
        });
        return;
      }

      // Cap index used for pagination/arrows at the last filled stop
      if (realLeading > stops.lastPageStartIndex) {
        realLeading = stops.lastPageStartIndex;
      }

      if (realLeading >= 0 && realLeading !== slideshow.current) {
        slideshow.current = realLeading;
      }

      if (shouldNormalize && usesGalleryInfiniteLoop(parentMedia, slideshow, getVisibleSlides)) {
        normalizeGalleryInfiniteScroll(slideshow, slidesContainer, getVisibleSlides);
      }

      updateDesktopPaginationUI(slideshow, slidesContainer, getVisibleSlides);
      updateGalleryArrowState(slideshow, slidesContainer, getVisibleSlides);

      if (parentMedia && isPhoneGalleryView(parentMedia)) {
        syncMobileGalleryHeight(parentMedia);
      }
    });
  }

  /**
   * Filled-end gallery must NOT add an end spacer — that spacer was sized to
   * `viewport - lastSlide` and let trackpad scroll show blank after the last media.
   * Native max scroll (equal-width columns) already stops at lastPageStartIndex.
   */
  function ensureGalleryScrollEndSpacer(parentMedia, slidesContainer, getVisibleSlides) {
    const existing = slidesContainer.querySelector('[data-gallery-scroll-spacer]');
    if (existing) existing.remove();
  }

  function initFullWidthCarousel(forceReinit) {
    const ctx = getGalleryContext();
    if (!ctx) return;

    const parentMedia = ctx.parentMedia;
    const slideshow = ctx.slideshow;
    const slidesContainer = ctx.slidesContainer;
    const carouselWrapper = ctx.carouselWrapper;

    hideDuplicateMediaSlides(slideshow);

    const arrows = slideshow.querySelector('slideshow-arrows');
    const configuredColumns = getConfiguredMediaColumns(parentMedia);
    const configuredGap = getConfiguredMediaGap(parentMedia);
    const layoutState = syncMediaColumnLayout(parentMedia, slidesContainer, configuredColumns, configuredGap);
    const isPhoneGallery = layoutState.isPhoneGallery;

    if (arrows) {
      arrows.style.display = 'flex';
      arrows.style.flexDirection = 'row';
      if (!isPhoneGallery) {
        arrows.setAttribute('position', 'center');
      } else {
        arrows.removeAttribute('position');
      }
    }

    slideshow.classList.add('slideshow--multiple-visible', 'slideshow--single-scroll');
    slidesContainer.style.removeProperty('display');
    slidesContainer.style.removeProperty('grid-template-columns');
    slidesContainer.style.removeProperty('flex-direction');
    slidesContainer.style.removeProperty('align-content');
    slidesContainer.style.removeProperty('height');
    slidesContainer.style.removeProperty('max-height');
    slidesContainer.style.scrollSnapType = 'x mandatory';
    slidesContainer.style.overflowX = '';
    slidesContainer.style.overflowY = 'hidden';

    // Hard-disable infinite loop on all devices (do not re-enable from legacy markup)
    slideshow.removeAttribute('infinite');
    const galleryRootEl = carouselWrapper.closest(
      '[data-media-gallery-full-width], [data-full-width-media-gallery]'
    );
    if (galleryRootEl) {
      galleryRootEl.dataset.galleryEnableInfinite = 'false';
    }

    const slides = slidesContainer.querySelectorAll('slideshow-slide');
    resetDesktopSlideSizing(slides);
    slides.forEach(function(slide) {
      slide.classList.remove('slideshow-slide--grid-feature', 'slideshow-slide--grid-hero-pair', 'slideshow-slide--grid-pair');
      slide.style.scrollSnapAlign = 'start';
      slide.style.scrollSnapStop = 'always';
    });

    function getVisibleSlides() {
      return Array.from(slideshow.querySelectorAll('slideshow-slide')).filter(function(slide) {
        return (
          slide.style.display !== 'none' &&
          !slide.hasAttribute('hidden') &&
          !slide.hasAttribute('data-gallery-clone')
        );
      });
    }

    if (!slideshow._originalNext) {
      slideshow._originalNext = slideshow.next.bind(slideshow);
      slideshow._originalPrevious = slideshow.previous.bind(slideshow);
    }

    const visibleCount = getVisibleSlides().length;
    const columnsOnDisplay = getGalleryColumnsOnDisplay(parentMedia);

    // Rebuild clones only when slide count / columns change (or forced boot).
    // Color switches that keep the same count skip expensive clone teardown (INP).
    const needsCloneSetup =
      forceReinit === true ||
      slideshow._galleryClonesSlideCount !== visibleCount ||
      slideshow._galleryClonesColumns !== columnsOnDisplay;

    if (needsCloneSetup) {
      setupGalleryInfiniteClones(slideshow, slidesContainer, parentMedia, getVisibleSlides);
      slideshow._galleryClonesSlideCount = visibleCount;
      slideshow._galleryClonesColumns = columnsOnDisplay;
    } else {
      ensureGalleryScrollEndSpacer(parentMedia, slidesContainer, getVisibleSlides);
    }

    slideshow._galleryCarouselReady = true;

    if (!slideshow._galleryNavBound) {
      slideshow._galleryNavBound = true;

      // After base slideshow.current setter (uses multi-visible nextIndex), re-apply
      // one-media filled-end arrow disable rules.
      const currentDescriptor = Object.getOwnPropertyDescriptor(
        Object.getPrototypeOf(slideshow),
        'current'
      );
      if (currentDescriptor?.set && currentDescriptor?.get && !slideshow._galleryCurrentPatched) {
        slideshow._galleryCurrentPatched = true;
        Object.defineProperty(slideshow, 'current', {
          configurable: true,
          enumerable: true,
          get: function () {
            return currentDescriptor.get.call(this);
          },
          set: function (value) {
            currentDescriptor.set.call(this, value);
            if (this.classList.contains('slideshow--single-scroll')) {
              updateGalleryArrowState(this, slidesContainer, getVisibleSlides);
            }
          },
        });
      }

    slideshow.next = function(event, options) {
      if (!this.classList.contains('slideshow--single-scroll')) {
        return this._originalNext(event, options);
      }

      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length === 0) return;

      const current = Math.max(0, getLeadingRealIndex(this, slidesContainer, getVisibleSlides));
      const stops = getGalleryScrollStops(parentMedia, visibleSlides.length);
      if (current >= stops.lastPageStartIndex) {
        updateGalleryArrowState(this, slidesContainer, getVisibleSlides);
        return;
      }

      scrollGalleryToRealIndex(this, slidesContainer, getVisibleSlides, current + 1, options);
      updateGalleryArrowState(this, slidesContainer, getVisibleSlides);
    }.bind(slideshow);

    slideshow.previous = function(event, options) {
      if (!this.classList.contains('slideshow--single-scroll')) {
        return this._originalPrevious(event, options);
      }

      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length === 0) return;

      const current = Math.max(0, getLeadingRealIndex(this, slidesContainer, getVisibleSlides));
      if (current <= 0) {
        updateGalleryArrowState(this, slidesContainer, getVisibleSlides);
        return;
      }

      scrollGalleryToRealIndex(this, slidesContainer, getVisibleSlides, current - 1, options);
      updateGalleryArrowState(this, slidesContainer, getVisibleSlides);
    }.bind(slideshow);

    }

    setupGalleryInfiniteWrap(slideshow, slidesContainer, getVisibleSlides, parentMedia);
    setupDesktopPaginationControls(slideshow, slidesContainer, getVisibleSlides);
    // Land instantly at first media + first pagination tab (no smooth scroll)
    settleGalleryAtStart(slideshow);
    setupGalleryVideoAutoplay(slideshow);

    if (isPhoneGallery) {
      parentMedia.querySelectorAll('slideshow-slide img.product-media__image').forEach(function(img) {
        if (img.complete) return;
        img.addEventListener(
          'load',
          function() {
            syncMobileGalleryHeight(parentMedia);
            updateGalleryScrollProgress(slideshow, slidesContainer);
          },
          { once: true }
        );
      });
    }
  }

  function setupGalleryInfiniteWrap(slideshow, slidesContainer, getVisibleSlides, parentMedia) {
    if (slideshow._galleryInfiniteWrapInit) return;
    slideshow._galleryInfiniteWrapInit = true;

    function maybeWrapFromEdges() {
      if (!slideshow.infinite || !slideshow.classList.contains('slideshow--single-scroll')) return;
      if (usesGalleryInfiniteLoop(parentMedia, slideshow, getVisibleSlides)) {
        normalizeGalleryInfiniteScroll(slideshow, slidesContainer, getVisibleSlides);
        syncLeadingPagination(slideshow, slidesContainer, getVisibleSlides);
        return;
      }

      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length <= 1) return;

      const allSlides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      syncLeadingPagination(slideshow, slidesContainer, getVisibleSlides);

      if (shouldWrapGalleryForward(slideshow, slidesContainer, getVisibleSlides)) {
        slideshow.select(allSlides.length, null, { animate: true });
        return;
      }

      if (shouldWrapGalleryBackward(slideshow, slidesContainer, getVisibleSlides)) {
        slideshow.select(-1, null, { animate: true });
      }
    }

    function onGalleryScroll() {
      scheduleGalleryScrollProgress(slideshow, slidesContainer);

      // While mouse drag-to-swipe is active, let slideshow own scrollLeft.
      if (slideshow.hasAttribute('dragging')) return;
      // Clamp immediately (don't wait for rAF) so trackpad can't flash blank
      clampGalleryScrollToFilledEnd(slideshow, slidesContainer, getVisibleSlides);
      syncLeadingPagination(slideshow, slidesContainer, getVisibleSlides, { normalize: false });
    }

    function onGalleryScrollEnd() {
      scheduleGalleryScrollProgress(slideshow, slidesContainer);

      if (slideshow.hasAttribute('dragging')) return;
      clampGalleryScrollToFilledEnd(slideshow, slidesContainer, getVisibleSlides);
      syncLeadingPagination(slideshow, slidesContainer, getVisibleSlides, { normalize: true });
    }

    slidesContainer.addEventListener('scroll', onGalleryScroll, { passive: true });

    if ('onscrollend' in slidesContainer) {
      slidesContainer.addEventListener('scrollend', onGalleryScrollEnd, { passive: true });
    } else {
      let scrollEndTimer;
      slidesContainer.addEventListener(
        'scroll',
        function() {
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(onGalleryScrollEnd, 120);
        },
        { passive: true }
      );
    }

    slidesContainer.addEventListener(
      'pointerup',
      function() {
        setTimeout(maybeWrapFromEdges, 180);
      },
      { passive: true }
    );
  }

  function setupGalleryZoomButton() {
    const section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    const trigger = section.querySelector('[data-gallery-zoom-trigger]');
    const zoomDialog = section.querySelector('zoom-dialog');
    const slideshow = section.querySelector('.media-gallery__carousel-wrapper slideshow-component');

    if (!zoomDialog || !slideshow || typeof zoomDialog.open !== 'function') return;

    function resolveZoomIndex(preferredSlide) {
      const allSlides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      const visibleSlides = allSlides.filter(function (slide) {
        return slide.style.display !== 'none' && !slide.hasAttribute('hidden');
      });

      let index =
        preferredSlide instanceof Element ? allSlides.indexOf(preferredSlide) : -1;

      if (index < 0) {
        index = typeof slideshow.current === 'number' ? slideshow.current : 0;
      }

      const currentSlide = allSlides[index];
      if (currentSlide && !visibleSlides.includes(currentSlide) && visibleSlides.length > 0) {
        index = allSlides.indexOf(visibleSlides[0]);
      }

      return index < 0 ? 0 : index;
    }

    function openZoomAt(index, event) {
      if (typeof zoomDialog.open !== 'function') return;
      zoomDialog.open(index, event);
    }

    if (trigger) {
      if (trigger._zoomClickHandler) {
        trigger.removeEventListener('click', trigger._zoomClickHandler);
      }

      trigger._zoomClickHandler = function (event) {
        event.preventDefault();
        event.stopPropagation();
        openZoomAt(resolveZoomIndex(null), event);
      };

      trigger.addEventListener('click', trigger._zoomClickHandler);
    }

    // Tap/click image media to zoom in. Zoom button stays separate.
    // Videos: deferred-media play/pause only — never open zoom from a video tap.
    // Swipe still opens nothing (slideshow suppresses click after drag).
    if (slideshow._zoomMediaOpenHandler) {
      slideshow.removeEventListener('click', slideshow._zoomMediaOpenHandler);
    }

    slideshow._zoomMediaOpenHandler = function (event) {
      if (!(event.target instanceof Element)) return;
      if (
        event.target.closest(
          'button, a, input, textarea, select, label, deferred-media, video, iframe, model-viewer, .media-gallery__zoom-button, slideshow-controls, slideshow-arrows'
        )
      ) {
        return;
      }

      const slide = event.target.closest('slideshow-slide');
      if (!slide || !slideshow.contains(slide)) return;

      // Video/model slides often include a poster <img>; never treat those as zoom targets.
      const isVideoOrModel =
        slide.getAttribute('data-media-is-video') === 'true' ||
        slide.classList.contains('product-media-container--video') ||
        slide.classList.contains('product-media-container--external_video') ||
        slide.classList.contains('product-media-container--model');
      if (isVideoOrModel) return;

      if (!slide.classList.contains('product-media-container--image')) return;

      event.preventDefault();
      openZoomAt(resolveZoomIndex(slide), event);
    };

    slideshow.addEventListener('click', slideshow._zoomMediaOpenHandler);
  }

  function resolveInitialGalleryColor() {
    const galleryRoot = document.querySelector(
      `[data-media-gallery-full-width][data-section-id="${sectionId}"]`
    );
    const fromAttr = galleryRoot?.getAttribute('data-active-media-color') || '';
    if (fromAttr) return normalizeString(fromAttr);

    const section = document.getElementById('shopify-section-' + sectionId);
    const checkedSwatch = section?.querySelector(
      'variant-picker .variant-option--swatches input[type="radio"]:checked'
    );
    if (checkedSwatch instanceof HTMLElement) {
      const key =
        checkedSwatch.getAttribute('data-media-color-key') ||
        (checkedSwatch instanceof HTMLInputElement ? checkedSwatch.value : '') ||
        '';
      return normalizeString(key);
    }
    return '';
  }

  function bindColorSwatchFiltering() {
    const section = document.getElementById('shopify-section-' + sectionId);
    if (!section || section.dataset.pzGalleryColorBound === 'true') return;
    section.dataset.pzGalleryColorBound = 'true';

    // Color filtering is owned exclusively by document `variant:update` (mediaOnly from
    // variant-picker + post-fetch). Do NOT also listen to section change/click — that
    // filtered the same color 2–3× per tap (INP). Sticky proxies still go through the picker.
  }

  function initialize() {
    bindColorSwatchFiltering();
    observeProductMediaLayout();
    observeMobilePdpContent();
    observeGalleryViewportChrome();

    const bootGallery = function () {
      const root =
        document.querySelector('[data-media-gallery-full-width][data-section-id="' + sectionId + '"]') ||
        document.querySelector('[data-media-gallery-full-width]');
      if (root?.dataset.galleryBooted === 'true') return;

      const ctx = getGalleryContext();
      if (!ctx?.slideshow) return;

      if (root) root.dataset.galleryBooted = 'true';

      const color = resolveInitialGalleryColor();
      if (color) {
        filterMediaByColor(ctx.slideshow, color, { isInitialBoot: true });
      } else {
        initFullWidthCarousel(true);
      }

      setupGalleryZoomButton();
      const idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 200); };
      idle(function () {
        preloadColorLeadImages(ctx.slideshow);
      });
    };

    // Single boot after slideshow CE is ready — avoids double filter/flash
    customElements.whenDefined('slideshow-component').then(bootGallery);
    if (customElements.get('slideshow-component')) {
      bootGallery();
    }

    customElements.whenDefined('zoom-dialog').then(setupGalleryZoomButton);
    setupGalleryZoomButton();
  }

  function scheduleCarouselRefresh() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshGalleryLayout, 150);
  }

  function onProductViewportChange() {
    initFullWidthCarousel(true);
    if (typeof window.refreshProductInformationLayout === 'function') {
      window.refreshProductInformationLayout();
    }
  }

  function onDesignModePreviewChange() {
    scheduleCarouselRefresh();
    if (typeof window.refreshProductInformationLayout === 'function') {
      clearTimeout(window._productInfoLayoutRefreshTimer);
      window._productInfoLayoutRefreshTimer = setTimeout(function() {
        window.refreshProductInformationLayout();
      }, 150);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  document.addEventListener('variant:update', (event) => {
    // Quick-add drawer also dispatches bubbling variant:update — never apply that
    // color filter to the live PDP gallery (leaves it empty until another click).
    if (isEventFromQuickAdd(event)) return;

    const colorValue = event?.detail?.data?.colorValue || '';
    const ctx = getGalleryContext();

    // Instant color filter — don't wait for section fetch / morph.
    if (colorValue && ctx?.slideshow) {
      const visible = filterMediaByColor(ctx.slideshow, colorValue);
      setupGalleryZoomButton();
      // If live DOM has no slides for this color, media-gallery.js will replace from fetch HTML.
      if (visible > 0) return;
    }

    // Size-only / non-color updates: keep current gallery; only refresh chrome.
    if (!event?.detail?.data?.newProduct && !colorValue) {
      setupGalleryZoomButton();
      return;
    }

    if (event?.detail?.data?.newProduct || (colorValue && !(ctx?.slideshow))) {
      requestAnimationFrame(() => {
        initFullWidthCarousel(true);
        setupGalleryZoomButton();
        const nextCtx = getGalleryContext();
        if (nextCtx?.slideshow) {
          if (colorValue) filterMediaByColor(nextCtx.slideshow, colorValue);
          scheduleGalleryVideoAutoplay(nextCtx.slideshow);
        }
      });
    }
  });

  // Color filtering is owned by variant:update (mediaOnly + post-fetch).
  // Do not re-filter on variant:selected — that duplicated work on every color/size click (INP).
  document.addEventListener('variant:selected', (event) => {
    if (isEventFromQuickAdd(event)) return;
    requestAnimationFrame(() => setupGalleryZoomButton());
  });

  document.addEventListener('media-gallery:replaced', (event) => {
    if (isEventFromQuickAdd(event)) return;

    const colorValue =
      event?.detail?.colorValue ||
      resolveInitialGalleryColor() ||
      '';

    requestAnimationFrame(() => {
      const ctx = getGalleryContext();
      if (!ctx?.slideshow) return;
      if (colorValue) {
        filterMediaByColor(ctx.slideshow, colorValue);
      } else {
        initFullWidthCarousel(true);
      }
      setupGalleryZoomButton();
    });
  });

  /** Ignore drawer-sourced gallery events so they cannot wipe the PDP slideshow. */
  function isEventFromQuickAdd(event) {
    try {
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (let i = 0; i < path.length; i++) {
        const node = path[i];
        if (!(node instanceof Element)) continue;
        if (
          node.matches?.(
            'quick-add-dialog, .quick-add-modal, #quick-add-dialog, .quick-add-modal__drawer-body, .quick-add-modal__media'
          )
        ) {
          return true;
        }
      }
    } catch (e) {
      /* ignore */
    }
    const target = event.target;
    return Boolean(
      target instanceof Element &&
        target.closest(
          'quick-add-dialog, .quick-add-modal, #quick-add-dialog, .quick-add-modal__drawer-body, .quick-add-modal__media'
        )
    );
  }

  /** Re-apply PDP color after quick-add close (recovers empty gallery if a leak already hit). */
  function restorePdpGalleryAfterQuickAdd() {
    const ctx = getGalleryContext();
    if (!ctx?.slideshow) return;
    delete ctx.slideshow.dataset.galleryColorFiltered;
    delete ctx.slideshow.dataset.galleryBootFiltered;
    const color = resolveInitialGalleryColor();
    if (color) {
      filterMediaByColor(ctx.slideshow, color);
    } else {
      initFullWidthCarousel(true);
    }
    setupGalleryZoomButton();
    scheduleGalleryVideoAutoplay(ctx.slideshow);
  }

  function isQuickAddCloseTarget(target) {
    if (!(target instanceof Element)) return false;
    if (target.id === 'quick-add-dialog' || target.tagName === 'QUICK-ADD-DIALOG') return true;
    if (target.classList.contains('quick-add-modal')) return true;
    return Boolean(target.closest('quick-add-dialog, #quick-add-dialog'));
  }

  // Capture: DialogCloseEvent does not bubble, but still reaches document in capture phase.
  document.addEventListener(
    'dialog:close',
    function (event) {
      if (!isQuickAddCloseTarget(event.target)) return;
      requestAnimationFrame(restorePdpGalleryAfterQuickAdd);
    },
    true
  );

  document.addEventListener(
    'close',
    function (event) {
      const target = event.target;
      if (!(target instanceof HTMLDialogElement)) return;
      if (!isQuickAddCloseTarget(target)) return;
      requestAnimationFrame(restorePdpGalleryAfterQuickAdd);
    },
    true
  );

  let resizeTimer;
  window.addEventListener('resize', scheduleCarouselRefresh);

  const productViewportQuery = window.matchMedia('(max-width: 1024px)');
  const galleryViewportQuery = window.matchMedia('(max-width: ' + PRODUCT_GALLERY_PHONE_MAX + 'px)');
  if (typeof productViewportQuery.addEventListener === 'function') {
    productViewportQuery.addEventListener('change', onProductViewportChange);
    galleryViewportQuery.addEventListener('change', onProductViewportChange);
  } else if (typeof productViewportQuery.addListener === 'function') {
    productViewportQuery.addListener(onProductViewportChange);
    galleryViewportQuery.addListener(onProductViewportChange);
  }
  
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:select', onDesignModePreviewChange);
    document.addEventListener('shopify:section:deselect', onDesignModePreviewChange);
    document.addEventListener('shopify:inspector:activate', onDesignModePreviewChange);
    document.addEventListener('shopify:inspector:deactivate', onDesignModePreviewChange);
  }

    global.initFullWidthCarousel = function(forceReinit) {
      initFullWidthCarousel(forceReinit !== false);
    };
  }

  global.initProductMediaGalleryFullWidth = initProductMediaGalleryFullWidth;
  global.initProductFullWidthMediaGallery = initProductMediaGalleryFullWidth;

  function bootProductMediaGalleryFullWidth() {
    document.querySelectorAll('[data-media-gallery-full-width], [data-full-width-media-gallery]').forEach(function(root) {
      var sectionId = root.getAttribute('data-section-id');
      if (!sectionId || root.getAttribute('data-gallery-initialized') === 'true') return;
      root.setAttribute('data-gallery-initialized', 'true');
      initProductMediaGalleryFullWidth(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootProductMediaGalleryFullWidth);
  } else {
    bootProductMediaGalleryFullWidth();
  }

  document.addEventListener('shopify:section:load', bootProductMediaGalleryFullWidth);

  document.addEventListener('shopify:section:unload', function(event) {
    var unloadedSectionId = event.detail && event.detail.sectionId;
    if (unloadedSectionId && global._productMediaGalleryInits) {
      delete global._productMediaGalleryInits[unloadedSectionId];
    }
  });
})(window);